export default __webpack_public_path__ + "static/media/personalDetails.dd53b79a.png";